import React from "react";
import classNames from "classnames/bind";
import styles from "./Table.module.css";

const cx = classNames.bind(styles);
const Table = ({ colum = [], data = [],onClick,info={stt:''},className="",style={} }) => {
  const handleClick = (data)=>{
    if(onClick){
      onClick(data)
    }
  }
  return (
    <table style={{...style}} className={cx("table",className)}>
      <thead>
        <tr>
          {colum.map((item, index) => {
            return <th className={cx("th")} key={index}>{item.label}</th>;
          })}
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => {
          return (
            <tr style={item?.stt === info?.stt ?{background:"#0040FF"}:{}} onClick={()=>handleClick(item)} key={index}>
              {colum.map((cl, index) => {
                return <td style={item?.stt === info?.stt ?{color:"#ffff"}:{}} className={cx("td")} key={index}>{item[cl.key]}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default Table;
